export interface StatusConfig {
	ohlc: boolean;
	bias: boolean;
	targetBtns: TargetButtons;
}
export interface ViewPortMargin {
	t: number;
	r: number;
	b: number;
}
export interface ViewPortConfig {
	margin: ViewPortMargin;
	fitBars: number;
	autoScaleReset: AutoScaleReset;
}
export enum ToolBarAlign {
	Left,
	Center,
	Right
}
export enum AutoScaleReset {
	Never = 0,
	Click = 1,
	Scroll = 2,
	ScrollAndClick = Click | Scroll
}
export enum TargetButtons {
	No,
	AllInOne,
	Separate,

}
export interface InfoBoxConfig {
	on: boolean;
}
export interface AlertsConfig {
	playSound: boolean;
}
export interface GeneralConfig {
	infoBox: InfoBoxConfig;
	dateFormat: string;
	timeHoursFormat: string;
	status: StatusConfig;
	viewPort: ViewPortConfig;
	toolBarAlign: ToolBarAlign;
	hotreload: boolean;
	tickersListShowIcons: boolean;
	dupeTickerInTile: boolean;
	alerts: AlertsConfig;
}
